import React from "react";
import Flagship from "../../core/flagship";
import {
  Button,
  Header,
  Icon,
  Loader,
  Card,
  Segment,
  Table,
  Modal,
  Input
} from "semantic-ui-react";
import { connect } from "react-redux";
import { getFormattedValue } from "../../utils/helpers";
import { Link } from "react-router";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";

class FileDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.s3Url = "https://" + Flagship.config.awsBucket + ".s3.amazonaws.com";
    this.folder = "file-drawer";

    this.state = {
      loading: true,
      files: [],
      grabbingLink: false,
      confirmingDelete: false
    };

    this.getFiles = this.getFiles.bind(this);
    this.getSignedUrl = this.getSignedUrl.bind(this);
    this.uploadError = this.uploadError.bind(this);
    this.missingFiles = this.missingFiles.bind(this);
    this.handleFinishedUpload = this.handleFinishedUpload.bind(this);
    this.uploadProgress = this.uploadProgress.bind(this);
    this.uploaderChildren = this.uploaderChildren.bind(this);
    this.renderAsTable = this.renderAsTable.bind(this);
    this.renderFilesInner = this.renderFilesInner.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.changeViewAs = this.changeViewAs.bind(this);
    this.getFileLink = this.getFileLink.bind(this);
    this.closeModals = this.closeModals.bind(this);
    this.handleRef = this.handleRef.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
  }

  componentDidMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
    document.title = "Flagship / File Drawer";
    this.getFiles();
  }

  handleFinishedUpload(data) {
    this.setState({
      uploading: false,
      dragging: false,
      progress: 0,
      grabbingLink: false,
      confirmingDelete: false
    });

    this.getFiles();
    Flagship.notify("File Uploaded.", "success");
    Flagship.event("file-upload", data.file.name, 0, this.props.userId);
  }

  uploadError(err) {
    Flagship.error("Upload failed. " + err, 0, this.props.userId);
  }

  getFiles() {
    let self = this;
    Flagship.get(
      "s3/list",
      {
        bucket: Flagship.config.awsBucket,
        folder: this.folder
      },
      function(response) {
        if (response.data.success === true && response.data.files !== null) {
          self.setState({
            files: response.data.files,
            loading: false
          });
        } else if (response.data.files === null) {
          self.setState({
            files: [],
            loading: false
          });
        } else {
          self.setState({
            loading: false
          });
          Flagship.error(
            "Failed to list file drawer files.",
            0,
            self.props.userId
          );
        }
      },
      function(err) {
        self.setState({
          loading: false
        });
        Flagship.error(
          "Failed to list file drawer files: " + err,
          0,
          self.props.userId
        );
      }
    );
  }

  getSignedUrl(file, callback) {
    Flagship.get(
      "s3/sign",
      {
        bucket: Flagship.config.awsBucket,
        objectName: this.folder + "/" + file.name,
        contentType: file.type
      },
      function(data) {
        callback(data.data);
      },
      function(err) {
        if (typeof console.error === "function") {
          console.error(err);
        }
      }
    );
  }

  missingFiles() {
    return this.state.loading ? (
      <Loader
        color="blue"
        className="flagship-loader"
        active
        inline="centered"
      />
    ) : (
      <div className="cf no-files-found">No files found.</div>
    );
  }

  uploadProgress(uploader, progress) {
    this.setState({
      uploading: true,
      dragging: false,
      progress
    });
  }

  changeViewAs(e, data) {
    this.props.actions.changeViewAs(data.value);

    // Update user preference in DB
    Flagship.post("user-view-as/" + this.props.userId, { viewAs: data.value });
  }

  renderFilesInner() {
    let self = this;
    if (this.state.uploading) {
      return (
        <div className="upload-progress">
          <Loader
            color="blue"
            className="flagship-loader"
            active
            inline="centered"
          />
          <div className="uploading-text">
            {typeof this.state.progress === "number"
              ? this.state.progress + "%"
              : this.state.progress}
          </div>
        </div>
      );
    } else if (this.props.screenWidth >= 1030) {
      return this.renderAsTable();
    }
    return (
      <Card.Group className="record-files cf">
        {this.state.files.length ? (
          this.state.files.map(function(file, i) {
            return (
              <Card key={"file-" + i} className="single-file">
                <Card.Content>
                  <Icon
                    color="grey"
                    circular
                    className="float-right"
                    name="file"
                  />
                  <Card.Header>
                    <Header as="h4">{file.Key.replace(/^.*[\\\/]/, "")}</Header>
                  </Card.Header>
                  <Card.Meta>
                    {getFormattedValue(file.Size, "filesize")}
                  </Card.Meta>
                  <Card.Description>
                    {getFormattedValue(file.LastModified, "time ago")}
                  </Card.Description>
                  <Card.Content extra>
                    <br />
                    <div className="ui file-actions">
                      <Button
                        as={Link}
                        to={
                          Flagship.config.apiBase +
                          "file?path=" +
                          encodeURIComponent(file.Key)
                        }
                        basic
                        primary
                        target="_blank"
                      >
                        View / Download
                      </Button>
                      <Button
                        primary
                        onClick={e => {
                          self.getFileLink(
                            e,
                            Flagship.config.apiBase +
                              "file?path=" +
                              encodeURIComponent(file.Key)
                          );
                        }}
                      >
                        Get Link
                      </Button>
                      <Button
                        color="red"
                        onClick={e => {
                          self.confirmDelete(
                            e,
                            file.Key.replace(/^.*[\\\/]/, "")
                          );
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  </Card.Content>
                </Card.Content>
              </Card>
            );
          })
        ) : this.state.dragging ? (
          <Card key="file-new" className="single-file">
            <Card.Content>
              <Icon
                color="green"
                circular
                inverted
                className="float-right"
                name="plus"
              />
              <Card.Header>
                <Header as="h4">Add File(s)...</Header>
              </Card.Header>
              <Card.Description>Drop to begin upload.</Card.Description>
              <Card.Content extra>
                <br />
                <br />
                <br />
              </Card.Content>
            </Card.Content>
          </Card>
        ) : (
          this.missingFiles()
        )}
      </Card.Group>
    );
  }

  getFileLink(e, url) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      grabbingLink: url
    });
  }

  confirmDelete(e, url) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      confirmingDelete: url
    });
  }

  closeModals() {
    this.setState({
      grabbingLink: false,
      confirmingDelete: false
    });
  }

  deleteFile(file) {
    let self = this;
    Flagship.post(
      "s3/deleteFile",
      {
        bucket: Flagship.config.awsBucket,
        objectName: this.folder + "/" + file
      },
      function() {
        self.setState(
          {
            confirmingDelete: false,
            grabbingLink: false
          },
          function() {
            self.getFiles();
            Flagship.notify("Deleted " + file);
          }
        );
      }
    );
  }

  copyToClipboard() {
    this.urlInput.focus();
    document.execCommand("copy");
    Flagship.notify("Copied URL.");
  }

  handleFocus(e) {
    e.target.select();
  }

  handleRef(urlInput) {
    this.urlInput = urlInput;
  }

  uploaderChildren() {
    return (
      <Segment>
        <Header as="h3">File Drawer</Header>
        <Modal
          open={this.state.grabbingLink !== false}
          closeOnEscape
          closeOnDimmerClick
          onClose={this.closeModals}
          closeIcon
        >
          <Modal.Header>Copy File Link</Modal.Header>
          <Modal.Content image>
            <Input
              ref={this.handleRef}
              style={{ width: "80%", marginRight: ".5em" }}
              value={this.state.grabbingLink}
              onFocus={this.handleFocus}
            />
            {document.queryCommandSupported("copy") ? (
              <Button primary onClick={this.copyToClipboard}>
                Copy Link
              </Button>
            ) : null}
          </Modal.Content>
        </Modal>

        <Modal
          open={this.state.confirmingDelete !== false}
          closeOnEscape
          closeOnDimmerClick
          onClose={this.closeModals}
          closeIcon
        >
          <Modal.Header>Confirm Deletion</Modal.Header>
          <Modal.Content>
            <Header as="h4">{this.state.confirmingDelete}</Header>
            <div>
              Are you sure you want to delete this file? There's no going back!
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="red"
              onClick={() => {
                this.deleteFile(this.state.confirmingDelete);
              }}
            >
              Delete
            </Button>
            <Button secondary onClick={this.closeModals}>
              Cancel
            </Button>
          </Modal.Actions>
        </Modal>
        {this.renderFilesInner()}
        {this.state.dragging ? (
          <div className="files-add-bottom">
            <em className="files-drag-and-drop">Drop files here.</em>
          </div>
        ) : (
          <div className="files-add-bottom">
            <Button primary icon="plus" content="Add Files" />
            <em className="files-drag-and-drop">
              Or drag and drop files right into this box.
            </em>
          </div>
        )}
      </Segment>
    );
  }

  renderAsTable() {
    let self = this;

    return (
      <Table className="files-table">
        <Table.Body>
          {this.state.files.length ? (
            this.state.files.map(function(file, i) {
              return (
                <Table.Row key={i} className="single-file-table-row">
                  <Table.Cell>
                    <Link
                      to={
                        Flagship.config.apiBase +
                        "file?path=" +
                        encodeURIComponent(file.Key)
                      }
                      target="_blank"
                    >
                      <Icon name="file" circular />{" "}
                      {file.Key.replace(/^.*[\\\/]/, "")}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>
                    <Link
                      to={
                        Flagship.config.apiBase +
                        "file?path=" +
                        encodeURIComponent(file.Key)
                      }
                      target="_blank"
                    >
                      {getFormattedValue(file.Size, "filesize")}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>
                    <Link
                      to={
                        Flagship.config.apiBase +
                        "file?path=" +
                        encodeURIComponent(file.Key)
                      }
                      target="_blank"
                    >
                      {getFormattedValue(file.LastModified, "time ago")}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>
                    <Button
                      primary
                      onClick={e => {
                        self.getFileLink(
                          e,
                          Flagship.config.apiBase +
                            "file?path=" +
                            encodeURIComponent(file.Key)
                        );
                      }}
                    >
                      Get Link
                    </Button>
                    <Button
                      color="red"
                      onClick={e => {
                        self.confirmDelete(
                          e,
                          file.Key.replace(/^.*[\\\/]/, "")
                        );
                      }}
                    >
                      Delete
                    </Button>
                  </Table.Cell>
                </Table.Row>
              );
            })
          ) : (
            <Table.Row>
              {this.state.dragging ? (
                <Table.Cell colSpan={3}>
                  <div className="cf no-files-found">
                    <Icon
                      name="plus"
                      size="small"
                      color="green"
                      circular
                      inverted
                    />
                    <em> Add file(s)...</em>
                  </div>
                </Table.Cell>
              ) : (
                <Table.Cell colSpan={3}>{this.missingFiles()}</Table.Cell>
              )}
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    );
  }

  handleDragEnter() {
    this.setState({
      dragging: true
    });
  }

  handleDragLeave() {
    this.setState({
      dragging: false
    });
  }

  render() {
    let children = this.uploaderChildren;

    const uploadOptions = {
      server: Flagship.config.url,
      s3path: this.folder,
      getSignedUrl: this.getSignedUrl,
      uploadRequestHeaders: {}
    };

    if (this.props.userRole !== "ae") {
      return (
        <DropzoneS3Uploader
          onFinish={this.handleFinishedUpload.bind(this)}
          onProgress={this.uploadProgress}
          onError={this.uploadError}
          children={children}
          passChildrenProps={false}
          s3Url={this.s3Url}
          maxSize={1024 * 1024 * 10000}
          upload={uploadOptions}
          onDragEnter={this.handleDragEnter}
          onDragLeave={this.handleDragLeave}
          className={this.state.dragging ? "files-dragging-over" : ""}
          style={{
            width: "100%",
            position: "relative",
            cursor: "pointer",
            overflow: "hidden",
            marginTop: "1em"
          }}
        />
      );
    } else {
      return (
        <Segment>
          <Header as="h3">File Drawer</Header>
          {this.renderFilesInner()}
          <em className="files-drag-and-drop">
            You don't have permission to upload files.
          </em>
        </Segment>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId,
    timerRunning: state.time.timerRunning,
    timeRecorded: state.time.timeRecorded,
    timeRecordedFormatted: state.time.timeRecordedFormatted,
    timerClient: state.time.timerClient,
    screenWidth: state.main.screenWidth
  };
}

export default connect(mapStateToProps, null)(FileDrawer);



// WEBPACK FOOTER //
// ./src/components/views/FileDrawer.js